/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:root{--mmi-background-color:#eef2f5;--mmi-bottombar-bg-color:#4e5b61;--mmi-bottombar-bg-darken:#354248;--mmi-primary-btn:#F3953F;--mmi-secondary-btn:#58a4c0;--mmi-btn-colour-3:#58a4c0;--mmi-btn-colour-4:#58a4c0;--green-color:#54D89F;--red-color:#EC506E;--login-page-bg-color:#4e5b61}.oona-container[_ngcontent-%COMP%]{padding:0 15px;margin-top:6px}.oona-report-pagination[_ngcontent-%COMP%]{margin:20px -7px 10px 0}.oona-report-pagination[_ngcontent-%COMP%]     .move-page-btn{background-color:#717d8d}.oona-report-pagination[_ngcontent-%COMP%]     .move-page-btn:hover{background-color:rgba(149,160,177,.35)}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/oona-report/oona-report.component.scss.shim.ngstyle.js.pre-build-optimizer.js